import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=3972d754&"
import script from "./logo.vue?vue&type=script&lang=js&"
export * from "./logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3972d754')) {
      api.createRecord('3972d754', component.options)
    } else {
      api.reload('3972d754', component.options)
    }
    module.hot.accept("./logo.vue?vue&type=template&id=3972d754&", function () {
      api.rerender('3972d754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/sidebar/components/logo.vue"
export default component.exports